import React from 'react'
import FeatherIcon from 'feather-icons-react';
import { Col, Row } from 'react-bootstrap'
import LoadingSkeleton from '../LoadingSkeleton';
import { Link } from 'react-router-dom';

import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

export default function PickUp(props) {
    const { loading } = props

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <React.Fragment>
            <Row className="payment-content mb-1 d-none">
                <Col lg={3} md={12} className="product-filter-left-content">
                </Col>
                <Col lg={9} md={12} className="product-filter-right-content">
                    {loading ? <LoadingSkeleton
                        height={200}
                    /> :
                        <div className="app-card mb-3" >
                            <div className={`product-filter-card st-border-light`}>
                                <div className="card-content d-block">
                                    <Row>
                                        <Col lg={7} md={12} className="border-right">
                                            <div className="d-flex  flex-column">
                                                <div className="card-icon mb-4" >
                                                    <div className="st-fs-16 st-fw-600 st-text-dark">Self Pickup</div>
                                                </div>
                                                <div>
                                                    <p>Add a curbside, drive-through, or in-store pickup. Specify your business hours, the pickup location, and add a brief instruction on how the pickup works for customers.</p>
                                                </div>
                                                <div className="mt-3">
                                                    <Link to={storeUrl + "/settings/shippings/self-pickup"}
                                                        className="text-decoration-none d-inline-block"
                                                    >
                                                        <button
                                                            type="submit"
                                                            className="st-btn st-btn-primary st-btn-sm d-flex align-items-center text-capitalize"
                                                            onClick={(e => { })}
                                                        >
                                                            <FeatherIcon
                                                                icon="plus"
                                                                size="16"
                                                                className="icon me-1" />
                                                            <span className="st-fs-13 st-fw-400">Add Pickup</span>
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={5} md={12}>
                                            <div className="payment-card__credit-cards" >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 26">
                                                    <path fill="#7ebbe8" d="M0 23h40v3H0z">
                                                    </path>
                                                    <circle cx="32" cy="5" r="5" fill="#457ba4">
                                                    </circle>
                                                    <path d="M32 11a7 7 0 017 7v5H25v-5a7 7 0 017-7z" fill="#457ba4">
                                                    </path>
                                                    <path fill="#e89234" d="M32 23H19v-9h13z">
                                                    </path>
                                                    <path fill="#fbd888" d="M24 14h3v3h-3z">
                                                    </path>
                                                    <path d="M17 23H0a1 1 0 011-1h15a1 1 0 011 1zM6 17h5v5H6z" fill="#7ebbe8">
                                                    </path>
                                                    <rect y="8" width="17" height="10" rx="1" fill="#7ebbe8">
                                                    </rect>
                                                    <path fill="#dcf2ff" d="M1.5 9.5h14v7h-14z">
                                                    </path>
                                                    <path d="M15 10v6H2v-6h13m1-1H1v8h15V9z" fill="#7ebbe8">
                                                    </path>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 26">
                                                    <path fill="#dcf2ff" d="M10 4h30v19H10z">
                                                    </path>
                                                    <path d="M10 0v7a3 3 0 006 0V6h6v1a3 3 0 006 0V6h6v1a3 3 0 006 0V0z" fill="#457ba4">
                                                    </path>
                                                    <path fill="#7ebbe8" d="M22 12h6v11h-6z">
                                                    </path>
                                                    <path fill="#e89234" d="M18 26H0V13h18z">
                                                    </path>
                                                    <path fill="#fbd888" d="M7 13h4v5H7z">
                                                    </path>
                                                    <path d="M16 0v7a3 3 0 006 0V0zm12 0v7a3 3 0 006 0V0z" fill="#7ebbe8">
                                                    </path>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 26">
                                                    <path d="M1 22h5v3a1 1 0 01-1 1H2a1 1 0 01-1-1v-3zm16 0h5v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-3z" fill="#457ba4">
                                                    </path>
                                                    <path d="M21 13H2L.3 14.7a1 1 0 00-.3.7V22a1 1 0 001 1h21a1 1 0 001-1v-6.6a1 1 0 00-.3-.7z" fill="#76bb8b">
                                                    </path>
                                                    <path d="M2.3 13.5l2-6a1.5 1.5 0 011.4-1h11.6a1.5 1.5 0 011.4 1l2 6z" fill="#dcf2ff">
                                                    </path>
                                                    <path d="M17.3 7a1 1 0 011 .7L20 13H3l1.8-5.3a1 1 0 011-.7h11.5m0-1H5.7a2 2 0 00-1.9 1.4L2 12.7 1.6 14h19.8l-.4-1.3-1.8-5.3a2 2 0 00-2-1.4z" fill="#76bb8b">
                                                    </path>
                                                    <path d="M1 11h2v2.3H1a1 1 0 01-1-1V12a1 1 0 011-1zm21 2.2h-2V11h2a1 1 0 011 1v.2a1 1 0 01-1 1z" fill="#76bb8b">
                                                    </path>
                                                    <path d="M3.3 17h1.4A1.3 1.3 0 016 18.3v1.4H3.3A1.3 1.3 0 012 18.3 1.3 1.3 0 013.3 17zm15 0h1.4a1.3 1.3 0 011.3 1.3 1.3 1.3 0 01-1.3 1.4H17v-1.4a1.3 1.3 0 011.3-1.3z" fill="#dcf2ff">
                                                    </path>
                                                    <path fill="#7ebbe8" d="M40 26H29V0h11z">
                                                    </path>
                                                    <path fill="#dcf2ff" d="M38 13h-9V2h9z">
                                                    </path>
                                                    <circle cx="34" cy="6" r="2" fill="#457ba4">
                                                    </circle>
                                                    <path d="M36 13h-5V9h3a2 2 0 012 2v2z" fill="#457ba4">
                                                    </path>
                                                    <path fill="#e89234" d="M24 10h4v5h-4z">
                                                    </path>
                                                    <rect x="25" y="9" width="8" height="2" rx="1" transform="rotate(-180 29 10)" fill="#457ba4">
                                                    </rect>
                                                </svg>
                                            </div>
                                            <div className="mt-3">
                                                <div className="st-text-dark">
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="15"
                                                        className="icon" />
                                                    <span className="ms-1">In-store pickup</span>
                                                </div>
                                                <div className="st-text-dark mt-2">
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="15"
                                                        className="icon" />
                                                    <span className="ms-1">Curbside pickup</span>
                                                </div>
                                                <div className="st-text-dark mt-2">
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="15"
                                                        className="icon" />
                                                    <span className="ms-1">Drive-through pickup</span>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>}
                </Col>
            </Row>
        </React.Fragment >
    )
}